import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useParams } from 'react-router';

import { useGetSection } from 'api/hooks/private/sections/GetSection';

import { PageContainer } from 'components/PageContainer';

import useSearchParamState from 'hooks/useSearchParamState';

import PeriodList from './Tabs/PeriodList';
import SectionEnrollmentList from './Tabs/SectionEnrollmentList';

type CourseTabs = 'periods' | 'enrollments';

export function ManageSection() {
  // get the course id
  const { id } = useParams<{ id: string }>();
  const [tabValue, setTabValue] = useSearchParamState({
    paramName: 'tab',
    initialState: 'periods',
    serialize: String,
    deserialize: String,
  });

  // fetch the section
  const section = useGetSection({
    variables: {
      id: id ?? '',
    },
    enabled: !!id,
  });

  const handleSetTabValue = (_event: React.SyntheticEvent, newValue: CourseTabs) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer title={section.data?.title}>
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        sx={{
          background: 'transparent',
          ml: -2,
          marginBottom: 2,
        }}
      >
        <Tab value="periods" label="Periods" />
        <Tab value="enrollments" label="Enrollments" />
      </Tabs>

      {id && tabValue === 'periods' && <PeriodList sectionId={id} />}
      {id && tabValue === 'enrollments' && <SectionEnrollmentList sectionId={id} />}
    </PageContainer>
  );
}

export default ManageSection;
